import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { application } from '@app/core/feature-flags/launch-darkly-user-property-mapper';

import { Lrmo } from './lrmo';

@Injectable({
  providedIn: 'root',
})
export class ApiHeaderService {
  headers: HttpHeaders;
  private _token: string;

  constructor() {
    this.headers = new HttpHeaders({
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'App-Platform-Name': application,
    });

    const lrmoId = new Lrmo(localStorage).getId();
    if (lrmoId) {
      this.headers = this.headers.append('Lrmo-Id', lrmoId);
    }
  }

  /**
   * @deprecated - do not use. Token access will be removed from this class imminently.
   * */
  get token() {
    return this._token;
  }

  setCacheType() {
    this.headers = this.headers.set('Cache-Control', 'no-cache');
  }

  resetCacheType() {
    this.headers = this.headers.delete('Cache-Control');
  }

  /**
   * @deprecated - do not use. Token access will be removed from this class imminently.
   * */
  setAccessToken(token: string) {
    this._token = token;
  }

  /**
   * @deprecated - do not use. Token access will be removed from this class imminently.
   * */
  revokeAccessToken() {
    this._token = undefined;
  }
}
